import _ from "lodash";
/** External */
import client from "lib/apolloClient/client";

/** Internal */
import {
  getOrganizationGradesQuery,
  getOrganizationSubjectsQuery,
} from "./CourseFilterQueries";

export const getOrganizationGradesFromCache = ({ variables }) => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationGradesQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getOrganizationSubjectsFromCache = ({ variables }) => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationSubjectsQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};
